import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams, Link } from "react-router-dom";
import Stripe from "stripe";
import { post } from "../../api";

const SuccessView = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("Loading...");
  const [totalAmount, setTotalAmount] = useState("");
  const { cypher_token } = useSelector((state) => state.initialApiReducer);

  const session_id = searchParams.get("sid");
  const pre_transaction_id = searchParams.get("pti");

  useEffect(() => {
    const fetchSessionDetails = async () => {
      if (!cypher_token || !session_id || !pre_transaction_id) {
        setMessage("Waiting...");
        return;
      }

      try {
        const decoded = atob(cypher_token);
        const [secretKey] = decoded.split("-");
        if (!secretKey) {
          setMessage("Invalid Stripe secret key.");
          return;
        }

        const stripe = new Stripe(secretKey);

        const session = await stripe.checkout.sessions.retrieve(session_id);
        const subscription = await stripe.subscriptions.retrieve(session.subscription);

        const amountCents = subscription?.plan?.amount;
        if (!amountCents) {
          setMessage("Could not retrieve subscription amount.");
          return;
        }

        const amountFormatted = `$${(amountCents / 100).toFixed(2)}`;
        setTotalAmount(amountFormatted);

        const payment_status = session.payment_status || "unpaid";
        const subscription_status = payment_status === "paid" ? 1 : 0;
        const subscriptionResponse = btoa(JSON.stringify(subscription));

        const response = await post(
          `/complete-subscription?pre_transaction_id=${pre_transaction_id}&post_transaction_id=${subscription.id}&payment_response=${subscriptionResponse}&subscription_status=${subscription_status}`
        );

        if (response?.status_code) {
          setMessage(response.message);
        } else {
          setMessage("Subscription completed, but no confirmation message received.");
        }

        // Run tracking only after successful response
        if (typeof window !== "undefined" && window.tdl) {
          try {
            window.tdl.convert({
              amount: amountFormatted,
              adv_sub: "darkroom checkout",
              adv_unique1: pre_transaction_id,
            });
          } catch (trackingError) {
            console.warn("Tracking pixel failed:", trackingError);
          }
        }
      } catch (error) {
        console.error("Error fetching session details:", error);
        setMessage("Failed to complete subscription.");
      }
    };

    fetchSessionDetails();
  }, [cypher_token, session_id, pre_transaction_id]);

  return (
    <div className="subscription_success_page loginrgstrform-section">
      <div className="loginrgstr-maincover">

      
      {totalAmount && pre_transaction_id && (
        <img
          src={`https://www.shareasale.com/sale.cfm?tracking=${pre_transaction_id}&amount=${totalAmount}&merchantID=160063&transtype=sale`}
          width="1"
          height="1"
          alt=""
        />
      )}

      <div className="account_verified">
        <h3 style={{ color: "#fff", marginBottom: '10px' }}>{message}</h3>
        <p>
          Go back to &nbsp; <Link to="/" class="outlined-button">Home Page</Link>
        </p>
      </div>
      </div>
    </div>
  );
};

export default SuccessView;
